// extracted by mini-css-extract-plugin
export default {"body":"Nav_body__J-cG6","item":"Nav_item__kaAYO","item__text":"Nav_item__text__-B-+B","item--active":"Nav_item--active__qMudX"};